import React, { useState, useEffect } from 'react'
import { AddNode, ArrowDown, ArrowUp, DropArrow, SearchIcon, SearchIconWhite } from "../../../assets/images";
import { Accordion, Card, Tab, Tabs } from "react-bootstrap";
import { Mention, MentionsInput } from "react-mentions";
import mentionsInputStyles from "../../NotificationMenu/mentionsInputStyles";
import mentionStyles from "../../NotificationMenu/mentionStyles";
import RegisteredUsers from "../../NotificationMenu/RegisteredUsers";
import EmergencyContact from "../../NotificationMenu/EmergencyContact";
import CustomContact from "../../NotificationMenu/CustomContact";
import CustomAccordion from './CustomAccordion';
import { DatePicker } from 'rsuite';
import { getEmergencyContactList, getMentionsList } from '../../../services/notifService';
import { addEscalations } from '../../../services/escalationSevices';
import EditModalContainer from '../../NotificationMenu/EditModalContainer';
import EscalationAccordian from './EscalationAccordian';

// const Email = "Email";
// const SMS = "SMS";
// const Mobile = "Mobile";

const EcsAccordion = ({
  // Email,
  // SMS,
  // Mobile,
  siteSelected,
  handleTimeChange,
  isNotifFormEnabled,
  emergencyContactList,
  categoryMaster,
  setEmergencyContactList,
  setCategoryMaster,
  siteListString,
  isDarkTheme,
  mentionList,
  setMentionList,
  setsubjectEmailMessage,
  setMentionSubjectEmailMessage,
  mentionSubjectEmailMessage,
  setemailMessage,
  setSmsMessage,
  setMentionEmailMessage,
  setMentionSMSMessage,
  setMentionMobileMessage,
  setmobileMessage,
  emailMessage,
  smsMessage,
  mobileMessage,
  subjectEmailMessage,
  transformedData,
  setTransformedData,
  // selectedUsersList,
  // setSelectedUsersList,
  // setSelectedAllRegUsers,
  // selectedAllRegUsers,
  waitTime,
  setWaitTime,
  userList,
  addNewClicked,
  count,
  setUserList,
  escalationLevelName,
  setEscalationLevelName,
  setEscalationLevels,
  escalationLevels,
  setEscalationLevelNameError,
  escalationLevelNameError,
  isEditCustomer,
  selectedEntity,
  setTopLeftCheck,
  topLeftCheck,
  selectAllHandler,
  searchHandlerOne,
  midLeftCheck,
  setMidLeftCheck,
  updateParentMainCustomerList,
  parentMainCustomerList,
  parentCount,
  updateParentCount,
  parentCustomContact,
  updateParentCustomContact,
  // customContact,
  // setCustomContact,
  // onAddClick,
  // mainCustomerList,
  // setMainCustomerList,
  // onDeleteClick,
  setEnableAdd,
  subjectHandler,
  messageHandler,
  handleLevelChange,
  setEmergencyContact,
  emergencyContact,
  handleRemoveLevel,
  handleAddLevel,
  setIsNotifFormEnabled,
  setSiteSelected,
  updateParentSelectedUsersList,
  parentSelectedUsersList,
  escalationLevelId,
  parentEmergencyContact,
  updateParentEmergencyContact 
 
}) => {

  const [accOpen, setAccOpen] = useState(false);

    
  console.log("userList", userList)
  console.log("escalationLevels", escalationLevels)
      
    
  // useEffect(() => {
  //               console.log("subjectEmailMessage", subjectEmailMessage); // Check if it's updated correctly
  // }, [subjectEmailMessage]);


  // useEffect(() => {
  //     if (siteListString != "") {
  //       //if(true){
  //       let temp;
  //       let loggedInUser = JSON.parse(localStorage.getItem('user'))
  //       temp = loggedInUser?.Id
  
  //       // Comment the below or make it false if you want don't want to check via the dummy data.
  //       if (false) {
  
  //         let dummy = [{
  //           "Category": "1",
  //           "ContactLevel": [
  //             1,
  //             2,
  //             3
  //           ]
  //         },
  //         {
  //           "Category": "2",
  //           "ContactLevel": [
  //             1,
  //             2
  //           ]
  //         }, {
  //           "Category": "3",
  //           "ContactLevel": [
  //             1
  //           ]
  //         }]
  
  //         let arr = dummy.map((item) => {
  //           let obj = {
  //             "Category": item.Category,
  //             "CategorySelected": false,
  //             "ContactLevel": item.ContactLevel.map(contactId => ({
  //               "contactId": contactId,
  //               "contactSelected": false
  //             }))
  //           }
  //           return obj
  //         });
  
  //         let tempArr = arr.map((item) => {
  //           let obj
  //           let isPresent = false
  //           let str = []
  //           for (let i = 0; i < selectedEmergCont.length; i++) {
  //             if (item.Category == selectedEmergCont[i].categoryChecked) {
  //               isPresent = true
  //               str = selectedEmergCont[i].contactLevels
  //               break;
  //             }
  //           }
  //           if (isPresent) {
  //             obj = {
  //               ...item,
  //               "CategorySelected": true,
  //               "ContactLevel": item.ContactLevel.map(contactId => ({
  //                 "contactId": contactId.contactId,
  //                 "contactSelected": str.includes(contactId.contactId.toString())
  //               }))
  //             }
  //           } else {
  //             obj = {
  //               ...item
  //             }
  //           }
  //           return obj
  //         });
  
  //         setEmergencyContactList(tempArr)
  //         setCategoryMaster(tempArr)
  
  //       }
  
  //       // Comment the below if you want to check via the dummy data.
  
  //       getEmergencyContactList(temp, siteListString).then((res) => {
  //         if (res.Status == "success") {
  //           let arr = res.Data.map((item) => {
  //             let obj = {
  //               "Category": item.Category,
  //               "CategorySelected": false,
  //               "ContactLevel": item.ContactLevel.map(contactId => ({
  //                 "contactId": contactId,
  //                 "contactSelected": false
  //               }))
  //             }
  //             return obj
  //           });
  
  //           let tempArr = arr.map((item) => {
  //             let obj
  //             let isPresent = false
  //             let str = []
  //             for (let i = 0; i < selectedEmergCont.length; i++) {
  //               if (item.Category == selectedEmergCont[i].categoryChecked) {
  //                 isPresent = true
  //                 str = selectedEmergCont[i].contactLevels
  //                 break;
  //               }
  //             }
  //             if (isPresent) {
  //               obj = {
  //                 ...item,
  //                 "CategorySelected": true,
  //                 "ContactLevel": item.ContactLevel.map(contactId => ({
  //                   "contactId": contactId.contactId,
  //                   "contactSelected": str.includes(contactId.contactId.toString())
  //                 }))
  //               }
  //             } else {
  //               obj = {
  //                 ...item
  //               }
  //             }
  //             return obj
  //           });
  //           console.log("tempArr", tempArr)
  //           setEmergencyContactList(tempArr)
  //           setCategoryMaster(tempArr)
  
  //         } else {
  //           setCategoryMaster([])
  //           setEmergencyContactList([])
  //         }
  //       })
  //         .catch((err) => console.log(err));
  
  //     } else {
  //       setCategoryMaster([])
  //       setEmergencyContactList([])
  //     }
  //   }, [siteListString])

  const handleAccordionToggle = (level) => {
    setAccOpen(accOpen === level ? null : level);  // Toggle open/close for individual level
  };
    
  const convertHHMMSSToSeconds = (time) => {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return (hours * 3600) + (minutes * 60) + seconds;
  };
        
        

  return (
 <div style={{width:"100%"}}>
      {escalationLevels.map((level) => (
      // <Accordion key={level.EscalationLevel} style={{ width: "100%" }}>
      //   <Card>
      //       <Accordion.Toggle
      //           as={Card.Header}
      //           disabled={!isNotifFormEnabled}
      //           eventKey={level.EscalationLevel.toString()}
      //           className="NotificationCardAccordion"
      //           style={{ padding: "0.6rem 1.25rem" }}
      //           onClick={() => handleAccordionToggle(level.EscalationLevel)}
      //       >
      //           <p>{level.EscalationLevelName}</p>
      //           <div>
      //               <button
      //               disabled={!isNotifFormEnabled} 
      //               type="button" 
      //               onClick={() => { handleRemoveLevel(level.EscalationLevel)}}
      //                style={{color:"red", backgroundColor: "transparent" }}>
      //                   Remove
      //               </button>
      //               <img
      //                   src={accOpen === level.EscalationLevel ? ArrowUp : ArrowDown}
      //                   alt={accOpen === level.EscalationLevel ? 'up arrow' : 'dropdown-arrow'}
      //               />
      //           </div>
      //       </Accordion.Toggle>

      //       <Accordion.Collapse eventKey={level.EscalationLevel.toString()}>
      //           <Card.Body style={{ padding: "10px" }}>
      //               <div className="mt20" style={{ float: "left", width: "100%" }}>
      //                   <p className="SiteNameText escalationText">Wait Time</p>
      //                   <DatePicker
      //                       format="HH:mm:ss,dd/MM/yyyy" // Format to display time as hh:mm:ss
      //                       selected={level.EscalationDueTime ? new Date(`1970-01-01T${level.EscalationDueTime}Z`) : null}
      //                       onChange={(date) => {
      //                         console.log("I am called")
      //                         const selectedTime = date.toISOString().substr(11, 8);
      //                         console.log("selectedTime", selectedTime)
      //                         setEscalationLevels(prevLevels =>
      //                           prevLevels.map(prevLevel => 
      //                           prevLevel.EscalationLevel === level.EscalationLevel
      //                           ? { ...prevLevel, EscalationDueTime: selectedTime }
      //                           : prevLevel
      //                            )
      //                           );
      //                       }} 
      //                       showTimeSelect // Enable time selection
      //                       style={{ width: 250, float: 'left' }}
      //                   />
      //               </div>

      //               <div className="mt20" style={{ float: "left", width: "100%" }}>
      //                   <p className="SiteNameText escalationText">Email Notification Template</p>
      //                   <div className="NotificationEmailMsgBox">
      //                       <div className="tab-content">
      //                           <div className="startDiv">
      //                               <MentionsInput
      //                                   style={mentionsInputStyles}
      //                                   singleLine
      //                                   placeholder="Enter Subject here"
      //                                   disabled={!isNotifFormEnabled}
      //                                   value={level.emailSubject}  
      //                                   onChange={(e, newValue, newPlainTextValue) => {
                                            
      //                                       setEscalationLevels(prevLevels =>
      //                                           prevLevels.map(prevLevel => 
      //                                               prevLevel.EscalationLevel === level.EscalationLevel
      //                                               ? { ...prevLevel, emailSubject: newPlainTextValue }
      //                                               : prevLevel
      //                                           )
      //                                       );
      //                                   }}
      //                               >
      //                                   <Mention data={mentionList} markup="{__display__}" style={mentionStyles} />
      //                               </MentionsInput>
      //                           </div>
      //                           <div className="EmailDivideLine"></div>
      //                           <div className="mentionDiv">
      //                               <MentionsInput
      //                                   style={mentionsInputStyles}
      //                                   placeholder="Enter message details here"
      //                                   disabled={!isNotifFormEnabled}
      //                                   rows={5}
      //                                   value={level.emailBody}  
      //                                   onChange={(e, newValue, newPlainTextValue) => {
                                            
      //                                       setEscalationLevels(prevLevels =>
      //                                           prevLevels.map(prevLevel => 
      //                                               prevLevel.EscalationLevel === level.EscalationLevel
      //                                               ? { ...prevLevel, emailBody: newPlainTextValue }
      //                                               : prevLevel
      //                                           )
      //                                       );
      //                                   }}
      //                               >
      //                                   <Mention data={mentionList} markup="{__display__}" style={mentionStyles} />
      //                               </MentionsInput>
      //                           </div>
      //                       </div>
      //                   </div>
      //               </div>

      //               {/* SMS Section */}
      //               <div className="mt08" style={{ float: "left", width: "100%" }}>
      //                   <p className="SiteNameText escalationText">SMS</p>
      //                   <div className="NotificationEmailMsgBox">
      //                       <div className="tab-content">
      //                           <div className="mentionDiv">
      //                               <MentionsInput
      //                                   style={mentionsInputStyles}
      //                                   placeholder="Enter message details here"
      //                                   disabled={!isNotifFormEnabled}
      //                                   rows={5}
      //                                   value={level.smsBody} 
      //                                   onChange={(e, newValue, newPlainTextValue) => {
                                            
      //                                       setEscalationLevels(prevLevels =>
      //                                           prevLevels.map(prevLevel => 
      //                                               prevLevel.EscalationLevel === level.EscalationLevel
      //                                               ? { ...prevLevel, smsBody: newPlainTextValue }
      //                                               : prevLevel
      //                                           )
      //                                       );
      //                                   }}
      //                               >
      //                                   <Mention data={mentionList} markup="{__display__}" style={mentionStyles} />
      //                               </MentionsInput>
      //                           </div>
      //                       </div>
      //                   </div>
      //               </div>

      //               {/* Mobile Notification Section */}
      //               <div className="mt08" style={{ float: "left", width: "100%" }}>
      //                   <p className="SiteNameText escalationText">Mobile Notification</p>
      //                   <div className="NotificationEmailMsgBox">
      //                       <div className="tab-content">
      //                           <div className="mentionDiv">
      //                               <MentionsInput
      //                                   style={mentionsInputStyles}
      //                                   placeholder="Enter message details here"
      //                                   disabled={!isNotifFormEnabled}
      //                                   rows={5}
      //                                   value={level.mobileBody}  
      //                                   onChange={(e, newValue, newPlainTextValue) => {
                                            
      //                                       setEscalationLevels(prevLevels =>
      //                                           prevLevels.map(prevLevel => 
      //                                               prevLevel.EscalationLevel === level.EscalationLevel
      //                                               ? { ...prevLevel, mobileBody: newPlainTextValue }
      //                                               : prevLevel
      //                                           )
      //                                       );
      //                                   }}
      //                               >
      //                                   <Mention data={mentionList} markup="{__display__}" style={mentionStyles} />
      //                               </MentionsInput>
      //                           </div>
      //                       </div>
      //                   </div>
      //               </div>

                    
      //               <RegisteredUsers
      //                   selectedUsersList={selectedUsersList}
      //                   setSelectedUsersList={setSelectedUsersList}
      //                   isNotifFormEnabled ={isNotifFormEnabled}
      //                   userList={userList}
      //                   setUserList={setUserList}
      //                   siteListString={siteListString}
      //                   selectedAllRegUsers={selectedAllRegUsers}
      //                   setSelectedAllRegUsers={setSelectedAllRegUsers}
      //                   isDarkTheme={isDarkTheme}
      //                   setEscalationLevels={setEscalationLevels}
      //                   level={level}
      //               />

      //               <EmergencyContact
      //                 selectedUsersList={selectedUsersList}
      //                 setSelectedUsersList={setSelectedUsersList}
      //                 isNotifFormEnabled={isNotifFormEnabled}
      //                 userList={userList} setUserList={setUserList}
      //                 siteListString={siteListString}
      //                 selectedAllRegUsers={selectedAllRegUsers}
      //                 setSelectedAllRegUsers={setSelectedAllRegUsers}
      //                 isDarkTheme={isDarkTheme}
      //                 categoryMaster={categoryMaster}
      //                 emergencyContactList={emergencyContactList}
      //                 setEmergencyContactList={setEmergencyContactList}
      //                 setCategoryMaster={setCategoryMaster}
      //               />

      //               <CustomContact
      //                   addNewClicked={addNewClicked}
      //                   customContact={customContact}
      //                   setCustomContact={setCustomContact}
      //                   onAddClick={onAddClick}
      //                   isNotifFormEnabled ={isNotifFormEnabled}
      //                   count={count}
      //                   mainCustomerList={mainCustomerList}
      //                   onDeleteClick={onDeleteClick}
      //                   setEnableAdd={setEnableAdd}
      //                   setMainCustomerList={setMainCustomerList}
      //                   isDarkTheme={isDarkTheme}
      //               />
      //               <div style={{ textAlign: "center",marginBottom:"10px" , display:"none"}}>
      //                    <button className="DataAccessEdit" style={{ width: "100px" }}>
      //                      <span className="ViewUpdate">Save</span>
      //                    </button>
      //                    <button className="DataAccessEdit" style={{ width: "100px" }}>
      //                     <span className="ViewUpdate">Edit</span>
      //                    </button>
      //                    <button className="DataAccessEdit" style={{ width: "100px" }}>
      //                     <span className="ViewUpdate">Update</span>
      //                    </button>
      //                    <button className="DataAccessEdit" style={{ width: "100px" }} type="submit">
      //                     <span className="ViewUpdate">Cancel</span>
      //                    </button>
      //               </div>

      //               <EditModalContainer
      //                   isDarkTheme={isDarkTheme}
      //                   isEditCustomer={isEditCustomer}
      //                   selectedEntity={selectedEntity}
      //                   setTopLeftCheck={setTopLeftCheck}
      //                   topLeftCheck={topLeftCheck}
      //                   selectAllHandler={selectAllHandler}
      //                   searchHandlerOne={searchHandlerOne}
      //                   midLeftCheck={midLeftCheck}
      //                   setMidLeftCheck={setMidLeftCheck}
      //               />

      //           </Card.Body>
      //       </Accordion.Collapse>
      //   </Card>
      // </Accordion>
      <EscalationAccordian
          key={level.EscalationLevel}
          accOpen = {accOpen}
          setAccOpen = {setAccOpen}
          level = {level}
          handleAccordionToggle = {handleAccordionToggle}
          setIsNotifFormEnabled = {setIsNotifFormEnabled}
          handleTimeChange= {handleTimeChange}
          siteSelected={siteSelected}
          setSiteSelected={setSiteSelected}
          isDarkTheme={isDarkTheme}
          setsubjectEmailMessage= {setsubjectEmailMessage}
          siteListString={siteListString}
          transformedData = {transformedData}
          setTransformedData = {setTransformedData}
          parentSelectedUsersList = {parentSelectedUsersList}
          updateParentSelectedUsersList = {updateParentSelectedUsersList}
          parentEmergencyContact = {parentEmergencyContact}
          updateParentEmergencyContact = {updateParentEmergencyContact}
          parentMainCustomerList = {parentMainCustomerList}
          updateParentMainCustomerList = {updateParentMainCustomerList}
          parentCount= {parentCount}
          updateParentCount = {updateParentCount}
          parentCustomContact = {parentCustomContact}
          updateParentCustomContact = {updateParentCustomContact}
          mentionList = {mentionList}
          setMentionList = {setMentionList}
          setMentionSubjectEmailMessage = {setMentionSubjectEmailMessage}
          mentionSubjectEmailMessage = {mentionSubjectEmailMessage}
          setemailMessage = {setemailMessage}
          setMentionEmailMessage = {setMentionEmailMessage}
          setSmsMessage = {setSmsMessage}
          setMentionSMSMessage = {setMentionSMSMessage}
          setmobileMessage = {setmobileMessage}
          setMentionMobileMessage = {setMentionMobileMessage}
          subjectEmailMessage = {subjectEmailMessage}
          emailMessage = {emailMessage}
          smsMessage = {smsMessage}
          mobileMessage = {mobileMessage}
          waitTime = {waitTime}
          setWaitTime = {setWaitTime}
          userList={userList}
          setUserList={setUserList}
          addNewClicked={addNewClicked}
          setEscalationLevelName= {setEscalationLevelName}
          escalationLevelName = {escalationLevelName}
          setEscalationLevels= {setEscalationLevels}
          escalationLevels = {escalationLevels}
          setEscalationLevelNameError = {setEscalationLevelNameError}
          escalationLevelNameError = {escalationLevelNameError}
          isNotifFormEnabled = {isNotifFormEnabled}
          selectedEntity={selectedEntity}
          isEditCustomer={isEditCustomer}
          setTopLeftCheck={setTopLeftCheck}
          topLeftCheck={topLeftCheck}
          selectAllHandler={selectAllHandler}
          searchHandlerOne={searchHandlerOne}
          midLeftCheck={midLeftCheck}
          setMidLeftCheck={setMidLeftCheck}
          setEnableAdd={setEnableAdd}
          subjectHandler = {subjectHandler}
          messageHandler = {messageHandler}
          handleAddLevel = {handleAddLevel}
          handleRemoveLevel = {handleRemoveLevel}
          handleLevelChange = {handleLevelChange}
          

      />
    ))}

 </div>
)
}

export default EcsAccordion